// Global state for POQ products
window.productsWithPriceOnQuote = [];

// Function to update POQ state using DOM and displayed price
window.updatePOQState = async function () {
  // Espera a que el DOM esté listo
  if (document.readyState === "loading") {
    await new Promise((resolve) =>
      document.addEventListener("DOMContentLoaded", resolve)
    );
  }
  const poqText =
    window.translations?.product?.pricing?.price_on_quote || "Price on Quote";
  const cartItems = document.querySelectorAll(".cart-item");
  window.productsWithPriceOnQuote = [];
  cartItems.forEach((item) => {
    const priceValue = item.getAttribute("data-item-price");
    if (priceValue === poqText) {
      const variantId = item.getAttribute("data-cart-id");
      const cartKey = item.getAttribute("data-cart-key");
      const productTitle = item
        .querySelector(".cart-item__name")
        ?.textContent?.trim();
      const sku = item.getAttribute("data-sku");
      const quantity = parseInt(
        item.querySelector(".quantity__input")?.value || 1
      );
      if (variantId && productTitle) {
        window.productsWithPriceOnQuote.push({
          variantId,
          cartKey,
          productTitle,
          sku: sku || "N/A",
          quantity
        });
      }
    }
  });
};

// Initial call to set state
window.updatePOQState();
window.addEventListener("cart_changed", window.updatePOQState);

// Global utility simplified
window.priceOnQuoteUtils = {
  hasProductsWithPriceOnQuote: function () {
    return window.productsWithPriceOnQuote.length > 0;
  },
  getProductsWithPriceOnQuote: function () {
    return window.productsWithPriceOnQuote;
  },
  ensureUpToDate: function () {
    // Return a promise that resolves when updatePOQState finishes
    return window.updatePOQState();
  }
};

/**
 * Price on Quote Handler
 * Manages the detection and handling of products with "price on quote" in the cart
 */

class PriceOnQuoteHandler {
  constructor() {
    this.init();
  }

  init() {
    // Wait for DOM to be ready
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", () =>
        this.setupEventListeners()
      );
    } else {
      this.setupEventListeners();
    }
  }

  setupEventListeners() {
    // Listen for cart changes to re-evaluate
    window.addEventListener("cart_changed", () => {
      this.checkForPriceOnQuoteProducts();
    });

    // Initial check
    this.checkForPriceOnQuoteProducts();
  }

  getDiscontinuedProducts() {
    const products = [];
    const cartItems = document.querySelectorAll(".cart-item");

    cartItems.forEach((item) => {
      const discontinuedFlag = (item.getAttribute("data-product-discontinued") || "")
        .toString()
        .trim()
        .toLowerCase();

      if (discontinuedFlag === "true") {
        const variantId = item.getAttribute("data-cart-id");
        const cartKey = item.getAttribute("data-cart-key");
        const productTitle = item.querySelector(".cart-item__name")?.textContent?.trim();
        const sku = item.getAttribute("data-sku");
        const quantity = parseInt(item.querySelector(".quantity__input")?.value || 1);

        if (variantId && productTitle) {
          products.push({
            variantId,
            cartKey,
            productTitle,
            sku: sku || "N/A",
            quantity
          });
        }
      }
    });

    return products;
  }

  hasDiscontinuedProducts() {
    return this.getDiscontinuedProducts().length > 0;
  }

  checkForPriceOnQuoteProducts() {
    if (
      window.priceOnQuoteUtils &&
      window.priceOnQuoteUtils.hasProductsWithPriceOnQuote()
    ) {
      this.updateCheckoutButtons();
    }
  }

  async addMultipleCartAttributes(attributes) {
    try {
      const response = await fetch("/cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ attributes: attributes })
      });

      if (!response.ok) {
        throw new Error("Failed to update cart attributes");
      }

      return response.ok;
    } catch (error) {
      console.error("Error updating cart attributes:", error);
      return false;
    }
  }

  async writeNote() {
    try {
      const cartResponse = await fetch("/cart.js");
      if (!cartResponse.ok) {
        return false;
      }

      const cart = await cartResponse.json();
      const attributes = cart.attributes || {};

      if (!attributes._price_on_quote_removed || !attributes._items_on_quote) {
        return false;
      }

      const note = `Price on Quote Items: ${attributes._items_on_quote}`;

      const updateResponse = await fetch("/cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({
          note: note
        })
      });

      if (!updateResponse.ok) {
        return false;
      }
      return true;
    } catch (error) {
      return false;
    }
  }

  updateCheckoutButtons() {
    // Add a data attribute to checkout buttons to indicate price on quote products exist
    const checkoutButtons = document.querySelectorAll(
      ".trigger-checkout-modal, #sendCheckoutButton, #sendApprovalButton"
    );
    checkoutButtons.forEach((button) => {
      button.setAttribute("data-has-price-on-quote", "true");
    });
  }

  showModal() {
    if (window.priceOnQuoteModal) {
      window.priceOnQuoteModal.show();
    } else {
      console.warn("Price on quote modal not found");
    }
  }

  hideModal() {
    if (window.priceOnQuoteModal) {
      window.priceOnQuoteModal.hide();
    }
  }

  // Function to remove products from cart
  async removeProductsFromCart(products) {
    try {
      const updates = {};
      products.forEach((product) => {
        const lineIdentifier = product.cartKey || product.variantId;
        if (lineIdentifier) updates[lineIdentifier] = 0;
      });

      const response = await fetch("/cart/update.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ updates })
      });

      if (!response.ok) {
        throw new Error("Failed to update cart");
      }

      return true;
    } catch (error) {
      console.error("Error removing products from cart:", error);
      return false;
    }
  }

  // Function to show error message
  showCartUpdateError(message) {
    const errorModal = document.getElementById("checkoutErrorModal");
    const notificationText = errorModal?.querySelector(".notification-text");
    if (!errorModal || !notificationText) return;

    notificationText.textContent = message;
    errorModal.classList.remove("hidden");
    setTimeout(() => errorModal.classList.add("hidden"), 5000);
  }

  showPriceOnQuoteError() {
    // Show error notification using existing system
    const errorModal = document.getElementById("checkoutErrorModal");
    if (errorModal) {
      const notificationText = errorModal.querySelector(".notification-text");
      if (notificationText) {
        notificationText.innerHTML =
          "We could not send the email for now, please try again later";
      }
      errorModal.classList.remove("hidden");
      setTimeout(() => errorModal.classList.add("hidden"), 5000);
    }
  }
}

// Initialize the handler when the script loads
const priceOnQuoteHandler = new PriceOnQuoteHandler();

// Make it globally accessible
window.priceOnQuoteHandler = priceOnQuoteHandler;
